export default "<p>Pasquale De Luca (1865 - 1929). Scrittore italiano.</p>\n";